import { render, staticRenderFns } from "./QuestionsGridCard.vue?vue&type=template&id=acf6277c&"
import script from "./QuestionsGridCard.vue?vue&type=script&lang=js&"
export * from "./QuestionsGridCard.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsGridCard.vue?vue&type=style&index=0&id=acf6277c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports